import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";
import { connectionsApi } from "@/react/api";

export const useIgnoreConnection = (
  options?: UseMutationOptions<any, Error, string>,
) =>
  useMutation(
    (connectionId: string) => connectionsApi.ignoreConnection(connectionId),
    options,
  );
